import { Link } from "react-router-dom";
import { ChevronRight, Briefcase } from "lucide-react";

/** "Work Hub / <Page>" breadcrumb shown at the top of every Work Hub page. */
export default function WorkHubBreadcrumb({ current, trail = [], className = "" }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="work-hub-breadcrumb" className={`flex items-center gap-1.5 text-xs font-medium text-slate-500 ${className}`}>
      <Link to="/work-hub" className="inline-flex items-center gap-1.5 text-slate-500 hover:text-indigo-600"><Briefcase className="h-3.5 w-3.5" />Work Hub</Link>
      {trail.map(([label, to]) => (
        <span key={label} className="inline-flex items-center gap-1.5"><ChevronRight className="h-3.5 w-3.5 text-slate-300" /><Link to={to} className="hover:text-indigo-600">{label}</Link></span>
      ))}
      <ChevronRight className="h-3.5 w-3.5 text-slate-300" />
      <span className="text-slate-800" aria-current="page">{current}</span>
    </nav>
  );
}

/** Wraps an existing page (Clients, Tasks) with the Work Hub breadcrumb, without changing the page. */
export function WorkHubPage({ current, padded = false, children }) {
  return (
    <>
      <WorkHubBreadcrumb current={current} className={padded ? "px-4 pt-4 md:px-6 md:pt-6" : "mb-4"} />
      {children}
    </>
  );
}
